module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-300.c006ff30.ttf";